import { Component, inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { PrimeNGConfig } from "primeng/api";
import { SkeletonModule } from "primeng/skeleton";

import { ParsedSequence, StatusBadgeConfig } from "@shared/models";
import { ClickableCardComponent } from "../clickable-card/clickable-card.component";
import { StatusBadgeComponent } from "../status-badge/status-badge.component";

@Component({
  selector: "app-sequence-card",
  standalone: true,
  imports: [ClickableCardComponent, StatusBadgeComponent, SkeletonModule],
  templateUrl: "./sequence-card.component.html",
  styleUrl: "./sequence-card.component.scss",
})
export class SequenceCardComponent implements OnInit {
  primengConfig = inject(PrimeNGConfig);
  router = inject(Router);

  noSequenceStatus: StatusBadgeConfig = {
    class: "status day-off",
    icon: "pi pi-calendar",
    text: "Day Off",
  };

  @Input() sequence!: ParsedSequence;

  ngOnInit(): void {
    this.primengConfig.ripple = true;
  }

  onSequenceClick(): void {
    if (this.sequence.noSequence) {
      return;
    } else {
      this.router.navigate([
        "/history",
        this.sequence.sequence,
        this.formattedDate(this.sequence.date),
        this.sequence.seat,
      ]);
    }
  }

  private formattedDate(date: string): string {
    const [month, day, year] = date.split("-");
    return `${month}-${day}-20${year}`;
  }

  showLabel(): boolean {
    return this.sequence.layovers.split("-").length <= 3;
  }
}
